// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"3071f0ef","703":"9185048f"}[chunkId] + ".chunk.js";
};